import {EmptyString, isNonEmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';

export class InvalidChangeAddress {
  public readonly key = 'InvalidChangeAddress';

  constructor(
    public readonly firstName: StringUnion,
    public readonly middleName: StringUnion,
    public readonly lastName: StringUnion,
    public readonly street: StringUnion,
    public readonly city: StringUnion,
    public readonly state: StringUnion,
    public readonly zip: StringUnion
  ) {}
}

export class ValidChangeAddress {
  public static create(
    firstName: StringUnion,
    middleName: StringUnion,
    lastName: StringUnion,
    street: StringUnion,
    city: StringUnion,
    state: StringUnion,
    zip: StringUnion
  ) {
    return isNonEmptyString(lastName) &&
      isNonEmptyString(firstName) &&
      isNonEmptyString(middleName) &&
      isNonEmptyString(street) &&
      isNonEmptyString(city) &&
      isNonEmptyString(state) &&
      isNonEmptyString(zip)
      ? new ValidChangeAddress(firstName, middleName, lastName, street, city, state, zip)
      : new InvalidChangeAddress(firstName, middleName, lastName, street, city, state, zip);
  }

  public readonly key = 'ValidChangeAddress';

  private constructor(
    public readonly firstName: NonEmptyString,
    public readonly middleName: NonEmptyString,
    public readonly lastName: NonEmptyString,
    public readonly street: NonEmptyString,
    public readonly city: NonEmptyString,
    public readonly state: NonEmptyString,
    public readonly zip: NonEmptyString
  ) {}
}

export type AddressChangeRequest = ValidChangeAddress | InvalidChangeAddress;

export const EmptyChangeAddressRequest = new InvalidChangeAddress(
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString()
);

export const isValidAddressChangeRequest = (
  addressChangeRequest: AddressChangeRequest
): addressChangeRequest is ValidChangeAddress => addressChangeRequest.key === 'ValidChangeAddress';
